import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateScheduledPushNotificationUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateScheduledPushNotification
  implements UpdateScheduledPushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UpdateScheduledPushNotificationUseCaseInterface.Params,
  ): Promise<UpdateScheduledPushNotificationUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${id}`,
      body,
      method: 'put',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
